import { PdfBrandConfig, PdfLayoutConfig } from '@common/types';

import { Content } from 'pdfmake/interfaces';
import { PartialSubmission } from 'types';
import { deserializePdfContent } from 'utils/pdf-content-serializer';
import { replacePlaceholdersInContent } from './pdf-header-placeholder-replacer';

export function loadHeaderContentFromDatabase(
  serializedContent: Record<string, any>,
  layoutConfigs?: Record<string, PdfLayoutConfig>,
): Content {
  return deserializePdfContent(serializedContent, layoutConfigs);
}

export function getPdfHeaderByBrand(brandConfig?: PdfBrandConfig, submission?: PartialSubmission | null) {
  if (brandConfig?.dynamicHeader) {
    const deserializedContent = loadHeaderContentFromDatabase(
      brandConfig.dynamicHeader.content,
      brandConfig.dynamicHeader.layoutConfigs,
    );
    return replacePlaceholdersInContent(deserializedContent, submission);
  }
  return undefined;
}
